import { useFormContext } from 'react-hook-form';

import { Button } from '@nesso/ui/primitives/button';
import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from '@nesso/ui/primitives/form';

import { MAX_SELECTED_APPROACHES } from '@/entities/session';
import type { GenerateNote } from '@/entities/session-note';
import {
    treatmentApproachesGroupsOrder,
    useTreatmentApproachesOptions,
} from '@/entities/treatment-approach';
import { MultiSelect } from '@/shared/ui/common/multi-select';

type Props = {
    onSubmit: (data: GenerateNote) => void;
    onCancel: () => void;
};

export function EditTreatmentApproachesContentPopoverForm({ onSubmit, onCancel }: Props) {
    const { handleSubmit, control } = useFormContext<GenerateNote>();
    const options = useTreatmentApproachesOptions();

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
            <FormField
                control={control}
                name="treatmentApproaches"
                render={({ field, fieldState }) => (
                    <FormItem>
                        <FormLabel>Treatment approach</FormLabel>
                        <FormControl>
                            <MultiSelect
                                options={options}
                                groupOrder={treatmentApproachesGroupsOrder}
                                selected={field.value}
                                onChange={field.onChange}
                                placeholder="Select…"
                                maxSelected={MAX_SELECTED_APPROACHES}
                                groupLabel={`Select up to ${MAX_SELECTED_APPROACHES}`}
                                className="w-full"
                                error={!!fieldState.error}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />

            <div className="flex flex-row gap-2 justify-end">
                <Button type="button" variant="outline" size="default" onClick={onCancel}>
                    Cancel
                </Button>
                <Button type="submit" size="default">
                    Update
                </Button>
            </div>
        </form>
    );
}
